import React, { useEffect } from "react";

function Tools() {
  useEffect(() => {
    // Initialize Bootstrap tooltips
    const tooltipElements = document.querySelectorAll(
      "[data-bs-toggle='tooltip']"
    );
    tooltipElements.forEach((element) => {
      new window.bootstrap.Tooltip(element);
    });
  }, []);

  return (
    <div className="container my-5">
      {/* Section Heading */}
      <div className="text-center mb-5">
        <div className="d-inline-block border-reddish pb-2">
          <h2 className="mb-0">Tools</h2>
        </div>
      </div>

      {/* Tools Icons */}
      <div className="d-flex justify-content-center flex-wrap gap-4">
        <img
          src="/image/figma.png"
          alt="Figma"
          width="40px"
          height="40px"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          data-bs-custom-class="custom-tooltip"
          data-bs-title="Figma"
        />
        <img
          src="/image/adobe-xd.png"
          alt="Adobe XD"
          width="40px"
          height="40px"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          data-bs-custom-class="custom-tooltip"
          data-bs-title="Adobe XD"
        />
        <img
          src="/image/invision.png"
          alt="InVision"
          width="40px"
          height="40px"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          data-bs-custom-class="custom-tooltip"
          data-bs-title="InVision"
        />
        <img
          src="/image/miro.png"
          alt="Miro"
          width="40px"
          height="40px"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          data-bs-custom-class="custom-tooltip"
          data-bs-title="Miro"
        />
        <img
          src="/image/adobe-illustrator.png"
          alt="Adobe Illustrator"
          width="40px"
          height="40px"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          data-bs-custom-class="custom-tooltip"
          data-bs-title="Adobe Illustrator"
        />
        <img
          src="/image/photoshop.png"
          alt="Photoshop"
          width="40px"
          height="40px"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          data-bs-custom-class="custom-tooltip"
          data-bs-title="Photoshop"
        />
      </div>
    </div>
  );
}

export default Tools;
